module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isResults) ? _c('div', {
    staticClass: "sd-loader"
  }, [(_vm.loader) ? _c('img', {
    attrs: {
      "src": "/static/geopsicon.gif",
      "height": "40",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loader && !_vm.isResults) ? _c('img', {
    attrs: {
      "src": "/static/icon.png",
      "height": "40",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (!_vm.loader) ? _c('a', {
    staticClass: "sd-error"
  }, [_vm._v("Keine Ergebnisse")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('span', [_c('h1', [_vm._v(_vm._s(this.errorMessage))]), _vm._v(" "), _c('a', {
    staticClass: "sd-contact",
    attrs: {
      "href": "http://geops.ch/impressum"
    }
  }, [_vm._v("geOps Kontakt")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c29f22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoaderAnimation.vue
// module id = 422
// module chunks = 1